import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { handleGetPrintAddons_list } from '../../../API/Model/quotaionModel';
import { getImageUrl } from '../../../MIS/Global';


const PrintAddonModal = ({ show, handleClose,singleQuote }) => {
  const [printAddons, setPrintAddons] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (singleQuote?.prints?.length > 0) {
      handleGetPrintAddons_list({ setLoading, setPrintAddons, singleQuote });
    } else {
      setPrintAddons([]);
    }
  }, [singleQuote]);

  return (
    <Modal show={show} onHide={handleClose} centered size="sm">
      <Modal.Header closeButton>
        <Modal.Title className="fs-6">Print Addons</Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-2">
        {loading ? (
          <div className="loader-wrapper">
            <div className="spinner-border text-primary" role="status" />
            <span className="loader-text">Loading addons...</span>
          </div>
        ) : printAddons.length > 0 ? (
          <div className="addon-list">
            {printAddons.map((addon, index) => (
              <div className="addon-item" key={index}>
                <img
                  src={getImageUrl(`${addon?.imgpath}`)}
                  alt={addon?.print_addon_name}
                  className="addon-thumb"
                />
                <span className="addon-name">{addon?.print_addon_name}</span>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-data">
            <span>No addons found.</span>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="py-2 px-3">
        <Button variant="secondary" size="sm" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>

      {/* Styles */}
      <style jsx>{`
        .addon-list {
          display: flex;
          flex-direction: column;
          gap: 6px;
          max-height: 300px;
          overflow-y: auto;
        }

        .addon-item {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 6px;
          border-radius: 4px;
          background-color: #f7f7f7;
        }

        .addon-thumb {
          width: 50px;
          height: 50px;
          object-fit: contain;
          border-radius: 4px;
          background: #fff;
          border: 1px solid #ddd;
        }

        .addon-name {
          font-size: 13px;
          font-weight: 500;
          color: #444;
        }

        .loader-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 30px 10px;
        }

        .loader-text {
          margin-top: 8px;
          font-size: 14px;
          color: #555;
        }

        .no-data {
          text-align: center;
          padding: 30px 10px;
          font-size: 14px;
          color: #888;
        }
      `}</style>
    </Modal>
  );
};

export default PrintAddonModal;
